import { BaseEndPointService } from '@app/services/base-service/base-endpoint.service';
import { Http, RequestOptionsArgs, Headers } from '@angular/http';
//import { AppSettings } from '../../common/AppSettings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { RoleType } from '../../common/App-key';
import { HttpObserve } from '@angular/common/http/src/client';
// import { HttpService } from '../../services/base-services/http.service';

export abstract class AutharizedEndPointService extends BaseEndPointService {
    static get UserInfo() {
        const userInfo = localStorage.getItem('currentUser');
        return userInfo ? JSON.parse(userInfo) : null;
    }
    static get AuthToken(): string {
        const userInfo = AutharizedEndPointService.UserInfo;
        if (userInfo && userInfo.access_token) {
            return 'Bearer ' + userInfo.access_token;
        } else {
            return undefined;
        }
    }
    static get UserEntityType(): number {
        const userInfo = AutharizedEndPointService.UserInfo;
        if (userInfo && userInfo.EntityType) {
            return <number>userInfo.EntityType;
        } else {
            return 0;
        }
    }

    // static get isPBAUser(): boolean {
    //     const userInfo = AutharizedEndPointService.UserInfo;
    //     if (userInfo && userInfo.RoleTypeId) {
    //         return userInfo.RoleTypeId === RoleType.PBA;
    //     } else {
    //         return false;
    //     }
    // }

    // static get isBAUser(): boolean {
    //     const userInfo = AutharizedEndPointService.UserInfo;
    //     if (userInfo && userInfo.RoleTypeId) {
    //         return userInfo.RoleTypeId === RoleType.BA;
    //     } else {
    //         return false;
    //     }
    // }

    // static get isAdminUser(): boolean {
    //     const userInfo = AutharizedEndPointService.UserInfo;
    //     if (userInfo && userInfo.RoleTypeId) {
    //         return userInfo.RoleTypeId === RoleType.Admin;
    //     } else {
    //         return false;
    //     }
    // }

    static get refreshAuthToken(): string {
        const userInfo = AutharizedEndPointService.UserInfo;
        if (userInfo && userInfo.refresh_token) {
            return userInfo.refresh_token;
        } else {
            return undefined;
        }
    }

    static brandId = 0;

    constructor(http: HttpClient, path: string) {
        super(http, path);
    }
    protected AddAuthToken(observe?: 'body'): {
        headers: HttpHeaders,
        observe: 'body'
    };
    protected AddAuthToken(observe: 'response'): {
        headers: HttpHeaders,
        observe: 'response'
    };
    protected AddAuthToken(observe: 'events'): {
        headers: HttpHeaders,
        observe: 'events'
    };
    protected AddAuthToken(observe: HttpObserve = 'body' ) {
        const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json')
        .set('Authorization', AutharizedEndPointService.AuthToken);
        const obj = {
            headers: httpHeaders,
            observe: observe
        };
        // ops = ops ? ops : {};
        // ops.headers = ops.headers || new Headers();
        // ops.headers.set('Authorization', AutharizedEndPointService.AuthToken);
        // ops.headers.set('Content-Type', 'application/json');
        return obj;
    }
    protected AddAuthTokenWithoutLogin(observe?: 'body'): {
        headers: HttpHeaders,
        observe: 'body'
    };
    protected AddAuthTokenWithoutLogin(observe: 'response'): {
        headers: HttpHeaders,
        observe: 'response'
    };
    protected AddAuthTokenWithoutLogin(observe: 'events'): {
        headers: HttpHeaders,
        observe: 'events'
    };

    protected AddAuthTokenWithoutLogin(observe: HttpObserve = 'body'): object {
        const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
        const obj = {
            headers: httpHeaders,
            observe: 'body' 
        };
        // ops = ops ? ops : {};
        // ops.headers = ops.headers || new Headers();
        // ops.headers.set('Authorization', AutharizedEndPointService.AuthToken);
        // ops.headers.set('Content-Type', 'application/json');
        return obj;
    }
    protected AddAuthTokenRaw(request: XMLHttpRequest) {
        request.setRequestHeader('Authorization', AutharizedEndPointService.AuthToken);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/base-service/autharized-endpoint.service.ts